export function formatRunDuration(value?: number) {
  if (value === undefined) return "—";
  if (value < 1_000) return `${Math.round(value)}ms`;
  if (value < 60_000) {
    return `${(value / 1_000).toFixed(value < 10_000 ? 2 : 1)}s`;
  }
  return `${Math.floor(value / 60_000)}m ${Math.round((value % 60_000) / 1_000)}s`;
}

export function formatRunPercent(value?: number) {
  return value === undefined ? "—" : `${(value * 100).toFixed(1)}%`;
}

export function formatRunTokenRate(value?: number) {
  return value === undefined
    ? "—"
    : `${value.toFixed(value >= 100 ? 0 : 1)} tok/s`;
}
